
import { defineComponent, ref } from 'vue';
import {
    openTermsOfService,
    openPrivacyPolicy
} from './use-face-recognition-enrollment';

export default defineComponent({
    emits: ['close', 'allow'],
    setup(_, { emit }) {
        const doNotShowAgain = ref(false);
        const allow = () => {
            emit('allow', doNotShowAgain.value);
        };

        return {
            openTermsOfService,
            openPrivacyPolicy,
            doNotShowAgain,
            allow
        };
    }
});
